module.exports = __webpack_public_path__ + "img/adventage_bg_desctop.97fa9898.webp";